const actionType = {
    SHOW_SUCCESS: 'SHOW_SUCCESS',
    SHOW_ERROR: 'SHOW_ERROR',
    SHOW_WARNING: 'SHOW_WARNING',
    SHOW_INFO: 'SHOW_INFO',
};
export default actionType;
